import { render, staticRenderFns } from "./WalletsList.vue?vue&type=template&id=2a642462&"
import script from "./WalletsList.vue?vue&type=script&lang=js&"
export * from "./WalletsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports